import React from 'react'
import {
  Box,
  Checkbox as ChakraCheckbox,
  CheckboxGroup as ChakraCheckboxGroup,
  CheckboxProps as ChakraCheckboxProps,
  CheckboxGroupProps,
  Spinner,
} from '@chakra-ui/react'
import { injectTheme } from '@hub/design-system-base'
import { checkboxTheme } from './theme'

injectTheme('Checkbox', checkboxTheme)

export type CheckboxProps = { isLoading?: boolean } & Pick<
  ChakraCheckboxProps,
  | 'as'
  | 'sx'
  | 'children'
  | 'aria-describedby'
  | 'aria-invalid'
  | 'aria-label'
  | 'aria-labelledby'
  | 'defaultChecked'
  | 'id'
  | 'isChecked'
  | 'isDisabled'
  | 'isInvalid'
  | 'isReadOnly'
  | 'isRequired'
  | 'name'
  | 'onChange'
  | 'onFocus'
  | 'spacing'
  | 'value'
  | 'colorScheme'
  | 'size'
>

export const Checkbox: React.FC<React.PropsWithChildren<CheckboxProps>> = props =>
  props.isLoading ? (
    <Box display={'flex'}>
      <Spinner size={'sm'} marginRight={'spacing-sm'} alignSelf={'center'} />
      {props.children}
    </Box>
  ) : (
    <ChakraCheckbox {...props} />
  )

export const CheckboxGroup: React.FC<React.PropsWithChildren<Pick<CheckboxGroupProps, 'defaultValue' | 'isDisabled' | 'onChange' | 'value'>>> = props => <ChakraCheckboxGroup {...props} />
